/*
The template block always renders the
article, even if the expiration time (expiresOn) has passed.
*/
import moment from "moment";

class TemplateBlockController {
  constructor($scope, $compile, $timeout, utils) {
    "ngInject";
    this.$scope = $scope;
    this.$compile = $compile;
    this.$timeout = $timeout;
    this.utils = utils;

    this.hasContent = true;
    this.contentType2Component = {
      'IMG': 'drm-image',
      'WYS': 'text',
      'MAP': 'text',
      'ALERT': 'text',
      'TTP': 'tickertape',
      'DIR': 'wegbewijzering'
    };
    this.currentArticle = null;
    this.articleTimer = null;
  }

  $onInit() {
    /* Watch until this component has been added to the DOM. */
    this.watcher = this.$scope.$watch(() => {
      const selector = `template-block-${this.$scope.$id}`;
      return document.getElementById(selector)
    }, (reference) => {
      if (reference) {
        /* Deregister the watcher. */
        this.watcher();
        this.compileContentTypeComponent(reference, this.templateBlock.contentType);
      }
    });

    /* Deep watch changes on the templateBlock.articles */
    this.$scope.$watch('vm.templateBlock.articles', articles => {
      this.articleChangeHandler(articles);
    }, true)
  }

  /* For now, assume that a template block supports only one contentType. */
  compileContentTypeComponent(reference, contentTypes) {
    const contentType = contentTypes[0];
    const tag = this.contentType2Component[contentType] ?
      this.contentType2Component[contentType] :
      'text';
    const html = `<${tag} article="vm.currentArticle"></${tag}>`;
    const component = this.$compile(html)(this.$scope);
    angular.element(reference).append(component);
  }

  getZIndex(templateBlock) {
    if (templateBlock.contentType.indexOf('ALERT') >= 0 ) return 10;
    if (templateBlock.contentType.indexOf('TTP') >= 0) return 8;
    return 0;
  }

  getBlockStyle() {
    const left = this.templateBlock.topLeft.x;
    const top = this.templateBlock.topLeft.y;
    const width = this.templateBlock.size.width;
    const height = this.templateBlock.size.height;
    const zIndex = this.getZIndex(this.templateBlock);
    return {
      left: `${left}px`,
      top: `${top}px`,
      width: `${width}px`,
      height: `${height}px`,
      'z-index': zIndex
    }
  }

  /* Articles may have been added, removed or updated. */
  articleChangeHandler(articles) {
    if (!articles || articles.length === 0) {
      this.setCurrentArticle(null);
    } else {
      /* Check if the current article is still in the list of articles. */
      let article;
      if (this.currentArticle) {
        /* Article may have been updated, so fetch the current version of the article. */
        article = _.find(articles, {id: this.currentArticle.id});
      }

      if (!article) {
        article = _.first(articles);
      }
      this.setCurrentArticle(article);
    }
  }

  /* Display duration is based on the minimum of article duration
  *  and the moment the article expires (validity);
  */
  getArticleDuration(article) {
    const expirationDuration = article.__validity.to.diff(moment());
    return Math.min(article.minimalDuration * 1000, expirationDuration);
  }

  isValidArticle(article) {
      return this.utils.isBetweenDates(article.__validity.from, article.__validity.to);
  }

  setCurrentArticle(article) {
    const articles = this.templateBlock ? this.templateBlock.articles : null;
    if (this.articleTimer) {
      this.$timeout.cancel(this.articleTimer);
    }

    this.currentArticle = article;

    /* Check if scheduling is necessary. */
    if (article) {
      const displayDuration = this.getArticleDuration(article);
      this.articleTimer = this.$timeout(() => {
        const articles = this.templateBlock ? this.templateBlock.articles : [];
        const validArticles = articles.filter(article => this.isValidArticle(article));
        if (articles.length > 0) {
          /* Get the index of the current article */
          const i = _.findIndex(articles, {id: this.currentArticle.id});
          const nextIndex = (i + 1) % articles.length;
          const nextArticle = articles[nextIndex];
          this.setCurrentArticle(nextArticle);
        } else {
          this.setCurrentArticle(null);
        }
      }, displayDuration);
    }
  }

  getDebugText() {
    const lines = [];
    lines.push(`Template block: ${this.templateBlock.id}`);
    lines.push(`Aantal artikelen: ${this.templateBlock.articles.length}`);
    if (this.currentArticle) {
      lines.push(`Huidig artikel id: ${this.currentArticle.id}`);
    }

    return lines.join('<br/>');
  }

  $onDestroy() {
    if (this.articleTimer) {
      this.$timeout.cancel(this.articleTimer);
    }
  }
}
export default TemplateBlockController;



// WEBPACK FOOTER //
// ./client/app/components/template-block/template-block.controller.js